/**
 * Utilidades de validación
 */

/**
 * Valida un email
 * @param {string} email - Email a validar
 * @returns {boolean} - true si es válido
 */
export const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

/**
 * Valida una contraseña (mínimo 6 caracteres)
 * @param {string} password - Contraseña a validar
 * @returns {boolean} - true si es válida
 */
export const isValidPassword = (password) => {
  return password && password.length >= 6;
};

/**
 * Valida un documento de identidad español (DNI, NIE, Pasaporte, otros)
 * - DNI: 8 dígitos + letra (ej: 12345678A)
 * - NIE: X/Y/Z + 7 dígitos + letra (ej: X1234567A)
 * - Pasaporte: 3 letras + 6 dígitos (ej: ABC123456)
 * - Otros: Al menos 5 caracteres alfanuméricos
 * @param {string} doc - Documento a validar
 * @returns {boolean} - true si es válido
 */
export const isValidDNI = (doc) => {
  if (!doc || typeof doc !== 'string') return false;
  
  const docUpper = doc.toUpperCase().trim();
  
  // DNI español: 8 dígitos + letra
  const regexDNI = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
  if (regexDNI.test(docUpper)) {
    const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
    const numero = parseInt(docUpper.substr(0, 8), 10);
    const letra = docUpper.charAt(8);
    return letra === letras.charAt(numero % 23);
  }
  
  // NIE español: X/Y/Z + 7 dígitos + letra
  const regexNIE = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
  if (regexNIE.test(docUpper)) {
    const nieMap = { 'X': '0', 'Y': '1', 'Z': '2' };
    const numero = parseInt(nieMap[docUpper.charAt(0)] + docUpper.substr(1, 7), 10);
    const letra = docUpper.charAt(8);
    const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
    return letra === letras.charAt(numero % 23);
  }
  
  // Pasaporte: 3 letras + 6 dígitos  
  const regexPasaporte = /^[A-Z]{3}[0-9]{6}$/;
  if (regexPasaporte.test(docUpper)) {
    return true;
  }
  
  // Otros documentos: al menos 5 caracteres alfanuméricos
  const regexOtros = /^[A-Z0-9]{5,20}$/;
  return regexOtros.test(docUpper);
};

/**
 * Valida un teléfono español (opcional)
 * @param {string} phone - Teléfono a validar
 * @returns {boolean} - true si es válido o está vacío
 */
export const isValidPhone = (phone) => {
  // Si está vacío es válido (campo opcional)
  if (!phone || phone.trim() === '') return true;
  const regex = /^[6789][0-9]{8}$/;
  return regex.test(phone);
};

/**
 * Valida que un campo no esté vacío
 * @param {string} value - Valor a validar
 * @returns {boolean} - true si no está vacío
 */
export const isRequired = (value) => {
  return value !== null && value !== undefined && value.toString().trim() !== "";
};

/**
 * Valida un nombre (solo letras, espacios, guiones y apóstrofes)
 * @param {string} name - Nombre a validar
 * @returns {boolean} - true si es válido
 */
export const isValidName = (name) => {
  const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s\-']+$/;
  return regex.test(name);
};
